import React, { useEffect, useMemo, useState } from 'react'
import IKnow from '@/components/IKnow/index'

interface IKnowOption {
    /** 每组规则唯一 */
    storeKey: string
    /** 相同规则的name放在一起 */
    names: string[]
    /** 提示内容 */
    tips: string
    /** 触发机制 */
    trigger: 'click' | 'auto'
    /** 展示类型 */
    type: 'once' | 'default'
}

interface Props {
    /** 支持多组规则 */
    options: IKnowOption[]
    /** 唯一标识 */
    name: string
}

let remember = {}

export function IKnowDynamic(props: Props) {
    const [clicked, setClicked] = useState(false)
    const { options, name } = props

    const opt = useMemo(() => {
        let find = options?.length ? options.find(o => o.names.includes(name)) : null
        return find || {}
    }, [options, name])

    const { trigger, storeKey, type, tips, ...rest } = opt

    const byClick = trigger === 'click'
    const disabled =
        !storeKey || (byClick && !clicked) || (type === 'once' && remember[storeKey] && remember[storeKey] !== name)

    useEffect(() => {
        if (!disabled) {
            remember[storeKey] = name
        }
    }, [disabled])

    if (!storeKey) {
        return props.children
    }

    return (
        <div
            onClick={() => {
                setClicked(true)
            }}>
            <IKnow
                disabled={disabled}
                name={storeKey}
                text={tips}
                placement="bottomLeft"
                innerStyle={{ minWidth: 220 }}
                {...rest}>
                {props.children}
            </IKnow>
        </div>
    )
}
